/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

import $ from 'jquery';

// import './contact-navs';

document.addEventListener('DOMContentLoaded', function () {
  const $contactPage = $('.page-template-hours');
  if ($contactPage.length != 0) {
    const $rightContainer = $contactPage.find('.contact-page__right');
    $rightContainer.empty();

    const $footerMaps = $('.footer-map-location');
    const $footerTables = $('.footer-hours .location-hours');

    $footerMaps.each(function (index) {
      const $map = $(this).clone(false, false);
      const $table = $($footerTables[index]).clone(true, false);
      const $contactLocation = $(
        `<div class="contact-page__location location-${index + 1}"></div>`
      );

      $table.find('.nav-tabs').each(function () {
        const $group = $(this);

        $(this)
          .find('.nav-link')
          .on('click', function (e) {
            e.preventDefault();

            // hide all panes, deactivate all tabs
            $group.siblings('.tab-content').find('.tab-pane').removeClass('is-active');
            $group.find('.nav-item').removeClass('is-active');
            $group.find('.nav-link').removeClass('is-active');
            $group.find('.nav-item').attr('aria-selected', false);

            // get the pane to be activated
            const $pane = $($(this).attr('href'));

            // show this pane
            $pane.addClass('is-active');

            // activate this tab
            $(this).parents('.nav-item').addClass('is-active');
            $(this).parents('.nav-item').attr('aria-selected', true);
            $(this).addClass('is-active');
          });
      });

      $map.find('.js-copy').each(function () {
        $(this).on('click', function () {
          const $copyObject = $(this);
          let text = $copyObject.data('copy');
          navigator.clipboard.writeText(text).then(
            function () {
              console.log('Async: Copying to clipboard was successful!');
              const $comp = $copyObject.find('.js-completed');
              $comp.text($comp.data('completed'));
              const $icon = $copyObject.find('.copy-icon');
              const $copiedIcon = $copyObject.find('.copied-icon');
              $icon.css('transform', 'scale(1.2)');
              setTimeout(() => {
                $icon.addClass('hidden');
                $copiedIcon.removeClass('hidden');
                $icon.css('transform', 'scale(1)');
              }, 300);
              setTimeout(() => {
                $comp.text('Copy');
                $icon.removeClass('hidden');
                $copiedIcon.addClass('hidden');
              }, 10000);
            },
            function (err) {
              console.error('Async: Could not copy text: ', err);
            }
          );
        });
      });

      $contactLocation.append($map);
      $contactLocation.append($table);
      $rightContainer.append($contactLocation);
    });
  }

  // custom sorting some of the fitlers

  function sortOemMakeFirst() {
    const oemName = 'Lincoln';
    const $makeFilterElem = $(`#dsp_make`);
    if ($makeFilterElem.length != 0) {
      const placeholderText = $makeFilterElem
        .parents('.filter-container')
        .attr('data-placeholder')
        .trim();

      // original - will store original option/value selected
      const original = $makeFilterElem.val();

      const $options = $makeFilterElem.find('option');

      $options.each(function () {
        const $option = $(this);
        if ($option.attr('data-option-name') == oemName) {
          $option.prependTo($makeFilterElem);
          return;
        }
      });
      $options.each(function () {
        const $option = $(this);
        if ($option.text().trim() == placeholderText) {
          $option.prependTo($makeFilterElem);
          return;
        }
      });

      // will apply original option/value selected
      $makeFilterElem.val(original);
    }
  }

  function sortYearFilter(id) {
    const $filterElem = $(`#${id}`);
    // original - will store original option/value selected
    const original = $filterElem.val();
    let $options = $filterElem.find('option');
    $options.detach().sort(function (a, b) {
      let at = $(a).text();
      let bt = $(b).text();
      return at < bt ? 1 : at > bt ? -1 : 0;
    });
    $options.appendTo($filterElem);
    // will apply original option/value selected
    $filterElem.val(original);
  }

  function sortPrioPassenger() {
    let passengerOptionsStarted = false;
    let $primaryPrependOption = {};
    let $secondaryPrependOption = {};
    const $filterElem = $(`#dsp_category`);
    const placeholder = $filterElem.parents('.filter-container').attr('data-placeholder').trim();
    const original = $filterElem.val();
    let $options = $filterElem.find('option');
    $options.each(function () {
      const text = $(this).text();

      if ($(this).attr('value') == undefined) {
        passengerOptionsStarted = false;
      }

      if (passengerOptionsStarted == true) {
        $(this).prependTo($filterElem);
      }

      if (text == 'Passenger Vehicle') {
        passengerOptionsStarted = true;
        $secondaryPrependOption = $(this);
      }
      if (text == placeholder) {
        $primaryPrependOption = $(this);
      }
    });

    // will apply original option/value selected and the primary prepend
    $secondaryPrependOption.prependTo($filterElem);
    $primaryPrependOption.prependTo($filterElem);
    $filterElem.val(original);
  }

  const $srpPage = $('.page-template-inventory');

  if ($srpPage.length != 0) {
    sortYearFilter('dsp_year_min');
    sortYearFilter('dsp_year_max');
    sortOemMakeFirst();
    sortPrioPassenger();
    try {
      $(document).on('inventory_search_filter_post_update', function () {
        sortYearFilter('dsp_year_min');
        sortYearFilter('dsp_year_max');
        sortOemMakeFirst();
        sortPrioPassenger();
      });
    } catch (err) {
      console.log(err);
    }
  }
});

// Change "Download Window Sheet" to "Download Window Sticker" on .inventory pages
const stickerContainer = document.querySelector('.vdp-page__sticker');

if (stickerContainer) {
  const btnText = stickerContainer.querySelector('.button__text');
  if (btnText) {
    const clean = btnText.textContent.trim().toLowerCase();
    if (clean.includes('download window sheet')) {
      btnText.textContent = btnText.textContent.replace(/sheet/i, 'Sticker');
    }
  }
}
